import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import AvFieldSelect from "components/Common/AvFieldSelect";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useModal from "hooks/useModal";
import { downloadCasbackTransactions } from "apis/transactions";

function CashbackDownloadFileType({ selectedValues }) {
  const [show, toggle] = useModal();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const fileTypes = [
    "csv", "pdf", "xlsx"
  ];
  return (
    <React.Fragment >
      <div>
        <Button
          color="primary"
          size="sm"
          onClick={toggle}
        >
          {t("Download Cashback Transactions")}
        </Button>
      </div>
      <Modal isOpen={show} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>
          {t("Download Cashback Transactions")}
        </ModalHeader>
        <ModalBody >
          <AvForm onValidSubmit={async (e, v) => {
            const today = new Date();
            const fileName = `Cashback Transaction ${today.toLocaleDateString("en-GB").replace(/\//g, "-")}.${v.fileType}`;
            setLoading(true);
            downloadCasbackTransactions({
              ...selectedValues,
              fileType: v.fileType,
              fileName
            }).then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                fileName
              );
              document.body.appendChild(link);
              link.click();
              setLoading(false);
            });
          }} >
            <AvFieldSelect
              name="fileType"
              label={t("File Type")}
              options={fileTypes.length > 0
                ? fileTypes.map((type) => {
                  return {
                    value: type,
                    label: type.toUpperCase()
                  };
                }) : ""
              }
              required
            />
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary"
                disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment >
  );
}

export default withTranslation()(CashbackDownloadFileType);